export const apiName: string = 'grupos-materiais';
export const gruposMateriaisRouter: string = 'grupos-materiais';
export const gruposMateriaisStorage: string = 'gruposmateriais';
export const gruposMateriaisModuleName: any = {plural: 'Grupos de materiais', single: 'Grupo'};

export const subgruposMateriaisRouter: string = 'subgrupos';
export const subgruposMateriaisModuleName: any = {plural: 'Subgrupos', single: 'Subgrupo'};

export const grupoMaterialCodigoMask: number = 3;

export const gruposQuery: any = {
    "where":{
        "ativo":true,
        "descricao":{"regexp":"/REPLACEHERE/i"}
    },
    "order":"descricao",
    "include":["contaContabil"]
};


/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/almoxarifado/grupos-materiais/shared/data.service.ts
 **/